module.exports = __webpack_public_path__ + "static/media/tutorial-5.2896671b.png";